<template>
    <div class="card">
        <div class="card-body" style="padding: 0 20px;">
            <div style="text-align: right;">
                <button data-v-1547f94d="" class="btn btn-black btn-close btn-close-black ms-auto me-3" type="button"
                    data-bs-dismiss="offcanvas" aria-label="Close" ref="closeBtnRef"></button>
            </div>
            <div class="d-flex justify-content-between align-items-center border-0 pb-0 pt-4">
                <div class="title">{{ i18n.global.locale == 'en'? detaileObj.title_en: detaileObj.title }}</div>
                <div class="d-flex justify-content-end">
                    <b-button v-permit="'hscode.modify'" style="background-color: #0AB39C;color:white" variant=""
                        v-b-toggle.searchCollapse1.searchCollapse2 @click="editHsCode" class="mx-4">
                        <i class="ri-edit-fill me-1 align-bottom"></i>
                        {{ getLangValue("base.edit") }}
                    </b-button>
                    <b-button v-permit="'hscode.delete'" style="background-color: #F06547;color:white" variant=""
                        v-b-toggle.searchCollapse1.searchCollapse2 @click="deleteHsCode">
                        <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                        {{ getLangValue("base.delete") }}
                    </b-button>
                </div>
            </div>
            <div class="basic-info ">
                <div class="w-100 my-4 " style="font-size: 16px; border-bottom: 1px solid #E9EBEC;">
                    {{ getLangValue('attribute.base') }}
                </div>
                <div class="d-flex justify-content-between">
                    <div class="col-3">
                        <label for="weight-field" class="form-label">
                            <span>{{ getLangValue("hscode.encodingId") }}:</span>
                        </label>
                        <div style="height: 40px;font-weight: 400;">
                            {{ detaileObj.hscode_id }}
                        </div>
                    </div>
                    <div class="col-3" v-if="detaileObj.code">
                        <label for="weight-field" class="form-label">
                            <span>{{ getLangValue("hscode.productCode") }}:</span>
                        </label>
                        <div style="height: 40px;font-weight: 400;">
                            {{ detaileObj.code }}
                        </div>
                    </div>

                    <div class="col-3">
                        <label for="weight-field" class="form-label">
                            <span>{{ getLangValue("attribute.create_time") }}:</span>
                        </label>
                        <div style="height: 40px;font-weight: 400;">
                            {{ dateFormat1(detaileObj.create_time) || "-" }}
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="weight-field" class="form-label">
                            <span>{{ getLangValue("attribute.last_time") }}:</span>
                        </label>
                        <div style="height: 40px;font-weight: 400;">
                            {{ dateFormat1(detaileObj.update_time) || "-" }}
                        </div>
                    </div>
                </div>
                <div class="col-100">
                    <label for="weight-field" class="form-label">
                        <span>{{ getLangValue("attribute.description") }}:</span>
                    </label>
                    <div style="min-height: 40px; font-weight: 400;word-wrap: break-word;">
                        {{ i18n.global.locale == 'en'? detaileObj.description_en:  detaileObj.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="group-tabs card" v-if="detaileObj.index_standards && detaileObj.index_standards.length">
        <div class="card-body">
            <!-- tab栏 -->
            <div v-if="groupList1.length">
                <div class="table_tab mb-0">
                    <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList1" v-model:current_tab="current_tab1"
                        :tabKey="'group1'" />
                    <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList2" v-model:current_tab="current_tab2"
                        :tabKey="'group2'" />
                    <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList3" v-model:current_tab="current_tab3"
                        :tabKey="'group3'" />
                </div>
            </div>
            <!-- 展示表格信息 -->
            <!-- style="height: calc(100% - 51.5px - 1.5rem);" -->
            <div v-if="selectedObj.index_standards[current_tab]">
                <div>
                    <div class="d-flex" style="border-bottom: 1px solid #E9EBEC;background-color: #F3F6F9;">
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{
                                getLangValue('hscode.indicatorName') }}</div>
                        <!-- <div style="flex:1; height: 40px; line-height: 40px;background-color: #E9EBEC;">{{
                                            getLangValue('attribute.defaultvalue') }}</div> -->
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('attribute.unit') }}
                        </div>
                        <div
                            style="flex:2; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC">
                            {{
                                getLangValue('attribute.reference') }}</div>
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('hscode.threshold') }}</div>
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('hscode.standard_judgment_method') }}</div>
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('hscode.is_it_applicable') }}
                        </div>
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('hscode.is_special_indicator')
                            }}</div>
                        <div
                            style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                            {{ getLangValue('hscode.calculation_mode')
                            }}</div>
                    </div>
                    <div>
                        <div class="d-flex" v-for="(item, k) in pageData" :key="k">
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ i18n.global.locale=='en'? item.name_en: item.name }}
                            </div>
                            <!-- <div style="flex:1; min-height: 40px; line-height: 40px;border: 1px solid #E9EBEC;padding-left: 10px;">{{ item.value }}
                                            </div> -->
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ i18n.global.locale=='en'? item.unit_en: item.unit }}
                            </div>
                            <div
                                style="flex:2; min-height: 40px; line-height: 40px;padding-left: 10px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC">
                                {{ i18n.global.locale=='en'? item.reference_en: item.reference
                                }}</div>
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;word-break: break-all;">
                                {{ item.threshold }}
                            </div>
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ item.judgement_model }}
                            </div>
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ item.is_applicable ? getLangValue("hscode.type.yes") :
                                    getLangValue("hscode.type.no") }}
                            </div>
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ item.is_specific ? getLangValue("hscode.type.yes") :
                                    getLangValue("hscode.type.no") }}
                            </div>
                            <div
                                style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                {{ item.calculation_mode }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="selectedObj.index_standards && Object.keys(selectedObj.index_standards).length">
                    <Pagination v-if="selectedObj.index_standards[current_tab].total"
                        v-model:page="pageNation[current_tab].currentPage"
                        v-model:perPage="pageNation[current_tab].pageSize" :prePageOption="[10, 20, 30, 40, 50]"
                        :pages="selectedObj.index_standards[current_tab].pageOption"
                        :tab_info_length="selectedObj.index_standards[current_tab].total" class="me-5 mt-0"
                        style="margin-top: 0 !important;">
                    </Pagination>
                </div>
            </div>
        </div>
    </div>
    <!-- <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert> -->
</template>

<script setup>
import { ref, toRefs, defineProps, watch, defineEmits, inject, computed } from "vue"
import { useRouter } from "vue-router"
import i18n from "@/i18n"
import { dateFormat1, getId } from "@/utils/common.js";
import Swal from "sweetalert2";
import { deleteHscode, } from "@/service"
import swiperTab from "@/components/common/swiperTab.vue";
import { getLangValue } from "@/utils/common"; //获取后端语言
// import useMessage from "@/utils/hooks/useMessage" //信息hooks
const props = defineProps({
    selectedObj: {
        type: Object,
        required: true,
        default: () => {
            return {}
        }
    },
    typeList: {
        type: Array,
        required: true,
        default: () => {
            return []
        }
    },
    titleList: {
        type: Array,
        required: true,
        default: () => {
            return []
        }
    },
})
const emits = defineEmits(["updateTree"])
const { selectedObj, typeList } = toRefs(props)
const openAlert = inject('openAlert')
// 弹框关闭按钮
const closeBtnRef = ref(null)
// // 当前选择tab
// const current_tab = ref(0)
// 分页存储信息  存储每个tab的分页信息
// const pageNation = ref([])
// 分页数据  存储每个tab分页数据
const pageData = ref([])
// hscode详情信息 
const detaileObj = ref({})
// 当前选中的tab
const current_tab = ref('group_0')
//第一层选中的tab
const current_tab1 = ref('')
//第二层选中的tab
const current_tab2 = ref('')
//第三层选中的tab
const current_tab3 = ref('')
const groupList = ref({}) // 组名list
const groupList1 = ref([]) //level 1
const groupList2 = ref([]) //level 2
const groupList3 = ref([]) //level3
const router = useRouter()
const pageNation = ref({}) //存储指标信息分页的信息  当前页  分页size
const pageNationStr = ref(computed(() => JSON.stringify(pageNation.value)));
const handleIndicatorCurrentChange = (index) => {
    //当前tab 分页数据改变  获取当前页的数据
    // console.log(index);
    if (Object.keys(selectedObj.value.index_standards).length && Object.keys(pageNation.value).length) {
        //手动去切换分页数据
        // 设置分页
        // console.log(selectedObj.value.index_standards);
        // console.log(selectedObj.value.index_standards[index]);
        const { indicatorList } = selectedObj.value.index_standards[index];
        const { currentPage, pageSize } = pageNation.value[index];
        selectedObj.value.index_standards[index].pageOption = setPageOption(indicatorList, pageSize)
        let startIndex = ((currentPage - 1) * pageSize) - 1 < 0 ? 0 : ((currentPage - 1) * pageSize);
        let endIndex = startIndex + pageSize;
        pageData.value = selectedObj.value.index_standards[index].indicatorList.slice(startIndex, endIndex)
    } else {
        pageData.value = [];
    }

}
const editHsCode = () => {
    // 编辑详情  如果是系统默认的顶级信息（服装、纱线...） 不能编辑
    // if (titleList.value.includes(detaileObj.value.title)) {
    //     openAlert({
    //         variant: "info",
    //         content:getLangValue("base.cannotEdit"),
    //     });
    //     return
    // }
    //关闭弹框
    closeBtnRef.value.click()
    //跳转至表单页
    router.push({ name: 'hscode_management_detail', query: { type: 'edit', id: detaileObj.value.id }, })
}
const onActiveTabId = (id) => {
    current_tab.value = id;
}
const deleteHsCode = () => {
    Swal.fire({
        title:getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? detaileObj.value.title + '?' : ''}`,
        text:getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText:getLangValue("base.done"),
        cancelButtonText:getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            //获取该code的子集 如果包含子集就不能删除
            let arr = getId(typeList.value, detaileObj.value.id);
            if (arr.length && arr[0].children.length) {
                console.log(`该code下包含${arr[0].children.length}个子集`);
                openAlert({
                    variant: "info",
                    content:getLangValue("base.delete_alert_hscode_info"),
                });
                return
            } else {
                //延迟2s操作
                let resp = await deleteHscode(detaileObj.value.id);
                if (resp) {
                    openAlert({
                        variant: resp.code == 1 ? "danger" : 'success',
                        content: resp.code == 1 ? resp.message :getLangValue("base.delete_success"),
                    });
                    if (resp.code == 0) {
                        //关闭弹框
                        closeBtnRef.value.click()
                        //刷新页面
                        emits('updateTree')
                    }
                }
            }
        }
    });
}

const setPageOption = (indicatorList, size) => {
    //设置分页信息
    let pageOption = []
    let numberOfPages = Math.ceil(indicatorList.length / size);
    for (let index = 1; index <= numberOfPages; index++) {
        pageOption.push(index);
    }
    return pageOption;
}

// const handleIndicatorCurrentChange = (index) => {
//     //当前tab下分页数据切换
//     if (detaileObj.value.index_standards.length && pageNation.value.length) {
//         //手动去切换分页数据
//         // 设置分页
//         const { indicatorList } = detaileObj.value.index_standards[index];
//         const { currentPage, pageSize } = pageNation.value[index];
//         detaileObj.value.index_standards[index].pageOption = setPageOption(indicatorList, pageSize)
//         let startIndex = ((currentPage - 1) * pageSize) - 1 < 0 ? 0 : ((currentPage - 1) * pageSize);
//         let endIndex = startIndex + pageSize;
//         pageData.value = detaileObj.value.index_standards[index].indicatorList.slice(startIndex, endIndex)
//     } else {
//         pageData.value = [];
//     }
// }

// const handlerToggleTab = (index) => {
//     //切换tab
//     if (current_tab.value == index) {
//         return;
//     }
//     current_tab.value = index;
//     pageData.value = detaileObj.value.index_standards[current_tab.value].pageData;
// }
const changTab = () => {
    // 根据current_tab 设置子集信息
    // console.log(current_tab.value);
    let arr = current_tab.value.split('_');
    if (arr.length == 2) {
        // 代表第一级  需要联动第二级  第三级
        // 第二级
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(current_tab.value));
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab2.value = ''
        current_tab3.value = ''
    } else if (arr.length == 3) {
        // 代表第二级  需要联动第三级
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab3.value = ''
    }
}
watch(pageNationStr, (newVal, oldVal) => {
    let newObj = JSON.parse(newVal);
    let oldObj = JSON.parse(oldVal);
    // console.log(oldObj);
    for (const item in newObj) {
        if (oldObj[item] && newObj[item] !== oldObj[item]) {
            const { pageSize } = newObj[item]
            const { pageSize: pageSize1 } = oldObj[item]
            // console.log(pageSize);
            // console.log(pageSize1);
            if (pageSize !== pageSize1) {
                // pageSize 发生改变
                // console.log(11111111);
                pageNation.value[current_tab.value].currentPage = 1
            }
        }
    }
    handleIndicatorCurrentChange(current_tab.value)
})

watch(pageNation, () => {
    //监听分页信息页面切换  然后去切换显示的数据
    handleIndicatorCurrentChange(current_tab.value)
}, { deep: true, })

watch(selectedObj, (val) => {
    //监听详情信息 
    detaileObj.value = { ...val };
    // let index_standards = []
    // if (val.index_standards !== null)
    //     for (let k in val.index_standards) {
    //         let m = {
    //             groupName: k,
    //             indicatorList: val.index_standards[k] ? val.index_standards[k] : [],
    //             pageData: val.index_standards[k] ? val.index_standards[k].slice(0, 10) : [],
    //             total: val.index_standards[k] ? val.index_standards[k].length : 0,
    //             pageOption: setPageOption(val.index_standards[k], 10)
    //         }
    //         index_standards.push(m)
    //         pageNation.value.push({
    //             currentPage: 1,
    //             pageSize: 10,
    //         })
    //     }
    // detaileObj.value.index_standards = index_standards;
    // pageData.value = detaileObj.value.index_standards.length ? detaileObj.value.index_standards[current_tab.value].pageData : [];
    groupList1.value = []
    groupList2.value = []
    groupList3.value = []
    let index_standards_list = {}
    if (detaileObj.value.index_standards !== null) {
        for (let k in detaileObj.value.index_standards) {
            //在这里处理多层数据 用不同的key
            const { children, group_name, group_name_en, index_standards } = detaileObj.value.index_standards[k]
            groupList1.value.push({
                name: i18n.global.locale == 'en' ? group_name_en : group_name,
                id: `group_${k}`,
            });
            let m = {
                groupName: k,
                indicatorList: index_standards ? index_standards : [],
                pageData: index_standards ? index_standards.slice(0, 10) : [],
                // currentPage: 1,
                // pageSize: 10,
                total: index_standards ? index_standards.length : 0,
                pageOption: setPageOption(index_standards, 10)
            }
            index_standards_list[`group_${k}`] = m
            pageNation.value[`group_${k}`] = {
                currentPage: 1,
                pageSize: 10,
            }
            // 第二级
            if (children.length) {
                for (let kk in children) {
                    const { children: children1, group_name: group_name1, group_name_en: group_name_en1  } = children[kk]
                    // groupList2.value.push(group_name1);
                    groupList2.value.push({
                        name: i18n.global.locale == 'en' ? group_name_en1 : group_name1 ,
                        id: `group_${k}_${kk}`
                    });
                    let m = {
                        groupName: k,
                        indicatorList: children[kk].index_standards ? children[kk].index_standards : [],
                        pageData: children[kk].index_standards ? children[kk].index_standards.slice(0, 10) : [],
                        // currentPage: 1,
                        // pageSize: 10,
                        total: children[kk].index_standards ? children[kk].index_standards.length : 0,
                        pageOption: setPageOption(children[kk].index_standards, 10)
                    }
                    // index_standards_list.push(m)
                    index_standards_list[`group_${k}_${kk}`] = m
                    // pageNation.value.push({
                    //     id: `group2_${kk}`,
                    //     currentPage: 1,
                    //     pageSize: 10,
                    // })
                    pageNation.value[`group_${k}_${kk}`] = {
                        currentPage: 1,
                        pageSize: 10,
                    }
                    // 第三级
                    if (children1.length) {
                        // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                        for (const item3 in children1) {
                            // console.log(item3);
                            const { group_name: group_name2, group_name_en: group_name_en2, index_standards: index_standards2 } = children1[item3]
                            groupList3.value.push({
                                name:i18n.global.locale == 'en' ? group_name_en2 : group_name2,
                                id: `group_${k}_${kk}_${item3}`
                            });
                            // let index_standards_list3 = children1.filter(item => item.group_name === groupList_3[item3])
                            let m = {
                                groupName: item3,
                                indicatorList: index_standards2 ? index_standards2 : [],
                                pageData: index_standards2 ? index_standards2.slice(0, 10) : [],
                                // currentPage: 1,
                                // pageSize: 10,
                                total: index_standards2 ? index_standards2.length : 0,
                                pageOption: setPageOption(index_standards2, 10)
                            }
                            // index_standards_list.push(m)
                            index_standards_list[`group_${k}_${kk}_${item3}`] = m
                            // pageNation.value.push({
                            //     id: `group3_${item3}`,
                            //     currentPage: 1,
                            //     pageSize: 10,
                            // })
                            pageNation.value[`group_${k}_${kk}_${item3}`] = {
                                currentPage: 1,
                                pageSize: 10,
                            }
                        }
                    }
                }

            }
        }
    }
    selectedObj.value.create_time = detaileObj.value.create_time;
    selectedObj.value.update_time = detaileObj.value.update_time;
    selectedObj.value.index_standards = index_standards_list;
    // console.log(selectedObj.value.index_standards[current_tab.value]);
    current_tab.value = groupList1.value.length ? `group_0` : ''
    current_tab1.value = groupList1.value.length ? `group_0` : ''
    pageData.value = Object.keys(selectedObj.value.index_standards).length ? selectedObj.value.index_standards[current_tab.value].pageData : [];
    // console.log(selectedObj.value);
    groupList.value = {
        groupList1: groupList1.value,
        groupList2: groupList2.value,
        groupList3: groupList3.value
    }
    changTab()
})
watch(current_tab, (val) => {
    changTab()
    pageData.value = Object.keys(selectedObj.value.index_standards).length ? selectedObj.value.index_standards[val].pageData : [];
})

</script>

<style scoped>
.title {
    font-weight: bold;
    font-size: 22px;
}
</style>